import { TableCell, TableRow } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import { validarTexto } from '../../utils/stringUtils'
import { PreviewItemNotaFiscal } from '../../types/notaFiscalApiTypes'

const useRowStyles = makeStyles(() => ({
  root: {
    '& > *': {
      borderBottom: 'unset'
    }
  }
}))

const PreVisualizarParametroNotaFiscal = (props: { row: PreviewItemNotaFiscal }) => {
  const classes = useRowStyles()

  const { row } = props

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell align="center">{validarTexto(row?.pedidoPlanilha, '-')}</TableCell>
        <TableCell align="center">{validarTexto(row?.valorNota, '-')}</TableCell>
      </TableRow>
    </React.Fragment>
  )
}

export { PreVisualizarParametroNotaFiscal }
